import { SurveyData } from './types';

export const formatValue = (value: string | number) => {
  if (typeof value === 'number') {
    const roundedValue = value.toFixed(3);
    return { display: roundedValue, full: value };
  }
  return { display: value, full: value };
};

export const transformArray = (inputArray: string[]): string[][] => {
  const result: string[][] = [];
  let currentSurvey: string[] = [];

  for (const item of inputArray) {
    if (item.toString().startsWith('Survey')) {
      if (currentSurvey.length > 0) {
        result.push(currentSurvey);
      }
      currentSurvey = [item];
    } else {
      currentSurvey.push(item);
    }
  }

  if (currentSurvey.length > 0) {
    result.push(currentSurvey);
  }

  return result;
};

export const extractUniqueValues = (
  data: SurveyData,
): { [key: string]: string[][] } => {
  const result: { [key: string]: string[][] } = {};

  for (const survey in data) {
    const uniqueValuesArray: string[] = [];

    data[survey].forEach((entry) => {
      if (Array.isArray(entry) && entry.length > 0) {
        const firstArray = entry[0];
        if (Array.isArray(firstArray)) {
          firstArray.forEach((element, index) => {
            uniqueValuesArray[index] = element;
          });
        }
      }
    });

    result[survey] = uniqueValuesArray.map((set) => Array.from(set));
  }

  return result;
};

export const dropdownSettingsTitles = ['Region', 'Site', 'Plume', ''];

export const calculateCategoryIndex = (
  categories: number[],
  value: number,
): number => {
  let closestIndex: number = -1;
  let closestDistance: number = Infinity;

  for (let i = 0; i < categories.length; i++) {
    let distance: number = Math.abs(categories[i] - value);
    if (distance < closestDistance) {
      closestDistance = distance;
      closestIndex = i;
    }
  }

  return closestIndex;
};

export const extractNumber = (inputString: string) => {
  const regex = /(\d+(\.\d+)?)\s*(%|SCFH)/;
  const match = inputString.match(regex);

  if (match) {
    return parseFloat(match[1]);
  } else {
    throw new Error('Incorrect number');
  }
};
